export function setStatic(key, value) {
  return {
    staticCallback: function staticCallback(componentClass) {
      componentClass[key] = value;
    }
  };
}
export default setStatic;